import OnboardingWizard from './pages/OnboardingWizard';

export { default as OnboardingLayout } from './components/OnboardingLayout';

export default OnboardingWizard;
